import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * HeroSection with photo background and floating glass panel.
 */
const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section
      id="hero"
      aria-labelledby="hero-heading"
      className="relative overflow-hidden landing-hero-photo"
      style={{
        minHeight: '660px',
        display: 'flex',
        alignItems: 'flex-end',
        backgroundImage: "url('/Morning Coffee.png')",
        backgroundSize: 'cover',
        backgroundPosition: '60% 24%',
      }}
    >
      <span className="sr-only">
        A person drinking morning coffee in soft natural light.
      </span>

      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background: [
            'linear-gradient(180deg, rgba(20,48,36,0.60) 0%, rgba(20,48,36,0.08) 25%, rgba(20,48,36,0) 45%)',
            'linear-gradient(90deg, rgba(241,237,227,0.34) 0%, rgba(241,237,227,0.10) 30%, rgba(241,237,227,0) 55%)',
            'linear-gradient(180deg, rgba(241,237,227,0) 72%, rgba(241,237,227,0.86) 92%, rgba(241,237,227,1) 100%)',
          ].join(','),
        }}
      />

      <div
        className="relative w-full container mx-auto px-4 sm:px-6 lg:px-8"
        style={{ maxWidth: '1280px', paddingTop: '130px', paddingBottom: '120px' }}
      >
        <div
          className="max-w-2xl rounded-[22px] p-6 sm:p-8 md:p-10"
          style={{
            backgroundColor: 'rgba(45, 90, 71, 0.46)',
            border: '1px solid rgba(255, 255, 255, 0.42)',
            boxShadow: '0 24px 60px rgba(17, 34, 28, 0.30)',
            backdropFilter: 'blur(14px)',
            WebkitBackdropFilter: 'blur(14px)',
          }}
        >
          <p className="inline-flex items-baseline gap-2 rounded-full border border-white/40 px-4 py-2 text-sm font-semibold text-white/95">
            <span className="text-2xl leading-none font-extrabold">167</span>
            <span>hours between sessions</span>
          </p>

          <h1
            id="hero-heading"
            className="mt-6 text-white leading-tight font-extrabold"
            style={{ fontSize: 'clamp(26px, 4.2vw, 40px)' }}
          >
            The hardest part of mental health isn't the appointment. It's every day before and after it.
          </h1>

          <p className="mt-5 text-base sm:text-lg text-white/90 leading-relaxed">
            A structured daily practice for the hours between sessions, whether you work with a clinician or find your own footing.
          </p>

          <button
            type="button"
            onClick={() => navigate('/register')}
            className="mt-7 inline-flex items-center gap-2 rounded-xl px-6 py-3 font-bold transition-all duration-200 hover:-translate-y-0.5"
            style={{ backgroundColor: 'var(--gold-accent)', color: 'var(--gold-accent-text)' }}
          >
            Start day 1
            <ArrowRight size={18} />
          </button>

          <p className="mt-3 text-sm text-white/85">Free to begin. Go at your own pace.</p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
